import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import {load} from 'redux/modules/lastEvents';

import { Col, Button, Alert, Row, Table, Panel } from 'react-bootstrap';

import moment from 'moment'
import _ from 'underscore';


import { ErrorAlert, LastActivityTable } from 'components'

const DAYS = 1

import { translate } from 'react-i18next';

@translate(['common'])
@connect(state => ({
  user: state.auth.user,
  timelineData: state.lastEvents.data,
}))
export default class LastEventsView extends Component {

  constructor(props) {

    super(props)

    this.state = {
      days: DAYS
    }
  }

  componentDidMount() {
    this.props.dispatch(load(this.props.params, moment().subtract(DAYS, 'd').unix(), moment().unix()));
  }


  render() {

    const { timelineData, params, dispatch, t } = this.props;



    return (
      <div>
        <Helmet title="Historique" />

        <div className="container">

          <div>

            {this.props.error &&
              <ErrorAlert buttonText={t("dashboardView.reload_page")} callback={() => this.props.load(0, {})} />
            }


            <div>
              <h3>{t("lastEventsView.events_history")} {/* <GaugeChart percent={90} />*/} </h3>
            </div>


            {/*<Row>

              <Col xs={12} md={12}>

                <h3>
                  Les {this.state.days} derniers jours :
								</h3>

              </Col>

            </Row>*/}

            <Row>
              <Col xs={12} md={2}>
                <div className="form-group">
                  <label for="sel1">{t("lastEventsView.periode")}</label>
                  <select className="form-control"
                    onChange={(v) => {
                      this.setState({ days: v.currentTarget.value })
                      dispatch(load(params, moment().subtract(parseInt(v.currentTarget.value), 'd').unix(), moment().unix()))
                    }}>
                    <option value="1" selected>24h</option>
                    <option value="2">48h</option>
                    <option value="3" >72h</option>
                    <option value="4">96h</option>
                  </select>
                </div>

              </Col>

            </Row>


            <Row>

              {generateTable(params, timelineData, 'panne', t("lastEventsView.pannes"))}

              {generateTable(params, timelineData, 'usager', t("lastEventsView.blocked_users"))}

              {generateTable(params, timelineData, 'indisponible', t("lastEventsView.indispo_sts"))}

            </Row>

          </div>

        </div>
      </div >
    );
  }
}


const generateTable = (params, data, type, title) => {

  var probs = _.chain(data.filter(r => r.type == type && r.end_date == null)).groupBy('identification_ID').map((vals, key) => {
    return vals[0]
  }).value()

  var norms = data.filter(r => r.type == type && r.end_date != null)
  var final = probs.concat(norms)
  var content = []
  var picto = type == 'indisponible' ? <i className="fa fa-minus-circle fa-1x" /> : <i className="fa fa-warning fa-1x" />
  var style = type == 'indisponible' ? 'warning' : 'danger'
  var header = <h4>{picto} {final.length} {title}</h4>

  if (data.length > 0) {
    content.push(
      <LastActivityTable
        data={final}
        title={title}
        type={type}
        params={params}
        style="primary"
      />
    )
  }

  return (
    <Col xs={12} md={4}>
      <Panel bsStyle={style} header={header} collapsible defaultExpanded={true}>
        {content}
      </Panel>
    </Col>
  )

}




